import React from 'react';
import { motion } from 'framer-motion';
import { BookOpenIcon } from 'lucide-react';
export function MethodSection() {
  return <section className="py-20 px-6" data-id="element-58">
      <div className="max-w-3xl mx-auto" data-id="element-59">
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.6
      }} className="bg-terracotta text-white p-8 md:p-12 rounded-3xl shadow-warm-lg relative overflow-hidden" data-id="element-60">
          {/* Decorative background element */}
          <div className="absolute -right-10 -top-10 opacity-10" data-id="element-61">
            <BookOpenIcon className="w-64 h-64" data-id="element-62" />
          </div>

          <div className="relative z-10" data-id="element-63">
            <h2 className="text-3xl md:text-4xl font-bold mb-6 text-cream" data-id="element-64">
              El Método de Repostería de Guerra (MRG)
            </h2>

            <p className="text-lg md:text-xl leading-relaxed text-cream/90 mb-6" data-id="element-65">
              Es una metodología diseñada para la economía actual que sustituye
              ingredientes costosos por técnicas de emulsión y batido de alto
              volumen.
            </p>

            <p className="text-lg md:text-xl leading-relaxed text-cream/90 font-medium bg-chocolate-dark/20 p-6 rounded-xl border border-cream/10" data-id="element-66">
              Logramos la misma humedad y sabor de un postre de lujo usando
              aceite vegetal, cacao en polvo y técnicas de horneado eficiente
              que ahorran gas y tiempo.
            </p>
          </div>
        </motion.div>
      </div>
    </section>;
}